import { useMemo } from 'react';
import { ChannelUserCard } from './ChannelUserCard';
import { ChannelUserCardCheckbox } from './ChannelUserCardCheckbox';
import { type User } from './UserList';
import { type UserDto } from '../../hooks/useGetUsers';

type ChannelUserInviteCardProps = {
  user: User;
  selectedUsers: UserDto[];
  setSelectedUsers: React.Dispatch<React.SetStateAction<UserDto[]>>;
  maxUsers: number;
};

export const ChannelUserInviteCard = ({
  user,
  selectedUsers,
  setSelectedUsers,
  maxUsers,
}: ChannelUserInviteCardProps) => {
  const maxReached = useMemo(
    () => selectedUsers.length >= maxUsers,
    [selectedUsers, maxUsers]
  );

  const disabled = useMemo(() => {
    if (!maxReached) return false;
    return selectedUsers.every((u) => u.id !== user.id);
  }, [maxReached, selectedUsers, user.id]);

  return (
    <ChannelUserCard
      user={user}
      selectedUsers={selectedUsers}
      setSelectedUsers={setSelectedUsers}
      disabled={disabled}
      right={
        <ChannelUserCardCheckbox
          user={user}
          selectedUsers={selectedUsers}
          disabled={disabled}
          onCheckedChange={(checked) => {
            setSelectedUsers((previous) =>
              checked
                ? previous.some((u) => u.id === user.id)
                  ? previous
                  : [...previous, user]
                : previous.filter((u) => u.id !== user.id)
            );
          }}
        />
      }
    />
  );
};
